import { createAction, handleActions } from 'redux-actions';

const initialState = {
  isFetching: false,
  isError: false,
  currentCharge: null,
  invoices: null,
};

// Actions

export const DATA_FETCH_STARTED = 'invoices/DATA_FETCH_STARTED';
export const DATA_FETCH_FAILED = 'invoices/DATA_FETCH_FAILED';
export const DATA_FETCH_SUCCEEDED = 'invoices/DATA_FETCH_SUCCEEDED';

// Action creators

const fetchDataOkPayload = (payload = {}) => {
  const { invoices = null, currentCharge = null } = payload;
  return {
    invoices,
    currentCharge,
  };
};

export const fetchData = createAction(DATA_FETCH_STARTED);
export const fetchDataError = createAction(DATA_FETCH_FAILED);
export const fetchDataOk = createAction(DATA_FETCH_SUCCEEDED, fetchDataOkPayload);

// Reducer

const handleFetchStarted = state => ({
  ...state,
  isFetching: true,
});

const handleFetchFailed = state => ({
  ...state,
  isFetching: false,
  isError: true,
});

const handleFetchSucceeded = (state, { payload }) => {
  const { invoices, currentCharge } = payload;
  return {
    ...state,
    isFetching: false,
    isError: false,
    invoices,
    currentCharge,
  };
};

export default handleActions(
  {
    [DATA_FETCH_STARTED]: handleFetchStarted,
    [DATA_FETCH_FAILED]: handleFetchFailed,
    [DATA_FETCH_SUCCEEDED]: handleFetchSucceeded,
  },
  initialState,
);

// Selectors

export const getInvoices = state => state.invoices;
